class TeleportModal {
  constructor() {
    this.shell = document.getElementById("global-modal-shell");
    if (!this.shell) return;

    this.injectionPoint = document.getElementById("modal-injection-point");
    this.triggers = document.querySelectorAll("[data-modal-trigger]");
    this.closeButtons = document.querySelectorAll("[data-modal-close]");
    this.lastFocus = null;

    this.init();
  }

  init() {
    // Open
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const sourceId = trigger.getAttribute("data-modal-trigger");
        this.open(sourceId, trigger);
      });
    });

    // Close
    this.closeButtons.forEach((btn) =>
      btn.addEventListener("click", () => this.close()),
    );

    // Overlay Click
    this.shell.addEventListener("click", (e) => {
      if (e.target === this.shell) this.close();
    });

    // ESC Support
    window.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        document.body.classList.contains("modal-open")
      ) {
        this.close();
      }
    });
  }

  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  open(sourceId, trigger) {
    const sourceEl = document.getElementById(sourceId);
    if (!sourceEl) return;

    this.lastFocus = trigger;

    // Reset Scrollbar Trick
    const scrollbarWidth = this.getScrollbarWidth();
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${scrollbarWidth}px`,
    );

    // Inject Content
    this.injectionPoint.innerHTML = sourceEl.innerHTML;
    this.injectionPoint.scrollTop = 0; // Reset scroll to top

    // Show
    document.body.classList.add("modal-open");
    this.shell.setAttribute("aria-hidden", "false");

    setTimeout(() => {
      const modalBox = this.shell.querySelector(".modal");
      if (modalBox) modalBox.focus();
    }, 100);
  }

  close() {
    document.body.classList.remove("modal-open");
    this.shell.setAttribute("aria-hidden", "true");

    // Reset scrollbar
    document.documentElement.style.setProperty("--scrollbar-width", `0px`);

    // Cleanup after animation finishes (Using arrow function to keep 'this' context)
    setTimeout(() => {
      this.injectionPoint.innerHTML = "";
    }, 350);

    if (this.lastFocus) {
      this.lastFocus.focus();
    }
  }
}

document.addEventListener("DOMContentLoaded", () => new TeleportModal());
